const SCOUT_FALLBACK_DEFAULT_MODEL = 'claude-opus-5-5';

/** Selectable Scout models (retired ids must not appear here). */
const SCOUT_SELECTABLE_MODEL_IDS = [
  'claude-opus-5-5',
  'claude-opus-4-7',
  'claude-opus-4-6',
  'claude-sonnet-4-6',
  'claude-haiku-4-5-20251001',
  'gpt-5.5',
  'gpt-5.5-pro',
  'gpt-5.4',
  'gpt-5.4-pro',
  'gpt-5.4-mini',
  'gemini-3.1-pro-preview',
  'gemini-3-flash-preview',
  'gemini-2.5-pro',
  'gemini-2.5-flash',
] as const;

export function getScoutDefaultModel(): string {
  const fromEnv = import.meta.env?.VITE_SCOUT_DEFAULT_MODEL;
  if (typeof fromEnv === 'string' && fromEnv.trim() !== '') {
    return fromEnv.trim();
  }
  return SCOUT_FALLBACK_DEFAULT_MODEL;
}

export type ScoutModelOption = { id: string; name: string };

/** Default model first; all options use model id as display name (admin model picker). */
export function buildScoutModels(): ScoutModelOption[] {
  const defaultId = getScoutDefaultModel();
  const restIds = SCOUT_SELECTABLE_MODEL_IDS.filter((id) => id !== defaultId);

  return [
    { id: defaultId, name: defaultId },
    ...restIds.map((id) => ({ id, name: id })),
  ];
}
